declare var LogonAspxRadAjaxLoadingPanel1ClientID: string; //see Logon.Aspx markup
declare var LogonAspxPasskeyConfig: any; // wok - 24.9.26 - Web/Passkey: see Logon.Aspx markup, null when the passkey logon is off

function readyFunctionLogonAspx() {
   console.log('is ready')
   // wok - 20.11.17 - added ClientJS for client fingerprinting
   var client = new ClientJS();
   var fingerprint = client.getFingerprint();
   $('#cFieldFingerprint').val(fingerprint.toString());
   // wok - 24.9.26 - Web/Passkey: passkeys.js is loaded by Logon.aspx.vb only when the passkey logon is enabled; the conditional UI
   // offers the passkeys of this site in the autofill of the user name field
   var lPasskeys: any = (<any>window).TdPasskeys;
   if (lPasskeys && LogonAspxPasskeyConfig) {
      lPasskeys.configure(LogonAspxPasskeyConfig);
      lPasskeys.startConditional();
   }
   $('#cFieldPassword').tooltip
   $('#form1').submit(function (e) {
      if (!$('#cFieldUserName').val() || !$('#cFieldPassword').val()) {
         console.log('Error')
         $('#cFieldUserName').css('borderColor', 'red');
         $('#cFieldPassword').css('borderColor', 'red');
         $('#cMessage').html('Username and/or Password can not be empty!');
         return false;
         //e.preventDefault();
      }
   });
}
// OG - 11.09.13 on blur event
$('input').blur(function () {
   if (this.id == "pUserName") {
      if (!emptyValidate($(this), $('#error4'))) return;
      if (!containsChar($(this), $('#error4'), "\\") && !containsChar($(this), $('#error4'), "@")) {
         $('#error4').text($('#domainError').text());
      }
   }
   if (this.id == "oldPassword")
      emptyValidate($(this), $('#error1'));

   if (this.id == "password")
      emptyValidate($(this), $('#error2'));

   if (this.id == "passwordCofirm")
      emptyValidate($(this), $('#error3'));

});
//get out of frame
if (parent.frames.length > 0) {
   parent.location = self.document.location
}

// wok - 29.9.26 - Web: a click on a logon button locks all logon buttons and turns a spinner in the clicked one (pBusyButtonId = its client id)
// until the server answers; the old scanner.gif below the buttons is gone. The passkey logon (passkeys.ts) locks the buttons for the
// WebAuthn ceremony with LockLogonButtons and releases them with UnlockLogonButtons when the ceremony fails or is cancelled.
function ShowWaitIndicator(pBusyButtonId?: string) {
   LockLogonButtons(pBusyButtonId);

   var message = document.getElementById('cMessage');
   message.innerHTML = 'Init session...';
   message.style.color = "#000000";

   return true;
}

var LogonButtonIds = ['cButtonLogon', 'cButtonStarter', 'cButtonPasskey'];

function LockLogonButtons(pBusyButtonId: string) {
   setLogonButtonsLocked(true, pBusyButtonId);
}

function UnlockLogonButtons() {
   setLogonButtonsLocked(false, null);
}

// the host (parent element, class td-busy-host) of the busy button gets td-busy: modern-ui.css turns the spinner in the button
function setLogonButtonsLocked(pLocked: boolean, pBusyButtonId: string) {
   for (var i = 0; i < LogonButtonIds.length; i++) {
      var lButton = <HTMLButtonElement>document.getElementById(LogonButtonIds[i]);
      if (lButton == null) { continue; }
      lButton.disabled = pLocked;
      var lHost = lButton.parentElement;
      if (lHost == null || !lHost.classList.contains('td-busy-host')) { continue; }
      if (pLocked && lButton.id == pBusyButtonId) { lHost.classList.add('td-busy'); } else { lHost.classList.remove('td-busy'); }
   }

   //OG - 13.9.13 disable a-Tag (wok - 29.9.26: an anchor has no "disabled" - the class td-locked switches its pointer events off)
   var cp = document.getElementById('changePassword');
   if (cp != null) {
      if (pLocked) { cp.classList.add('td-locked'); } else { cp.classList.remove('td-locked'); }
   }
}

function changePassword() {
   var oldPassword = $('#oldPassword');
   var password = $('#password');
   var passwordCofirm = $('#passwordCofirm');
   var pUserName = $('#pUserName');
   // wok - 20.11.17 - added ClientJS for client fingerprinting
   var cFieldFingerprint = $('#cFieldFingerprint');
   var cFieldPINorTAN = $('#cFieldPINorTAN');

   var e1 = $('#error1');
   var e2 = $('#error2');
   var e3 = $('#error3');
   var e4 = $('#error4');

   e1.removeClass('label');
   e1.addClass('labelD');
   e2.removeClass('label');
   e2.addClass('labelD');
   e3.removeClass('label');
   e3.addClass('labelD');
   e4.removeClass('label');
   e4.addClass('labelD');

   oldPassword.val('');
   password.val('');
   passwordCofirm.val('');
   pUserName.val('');

   oldPassword.removeClass('inputE');
   password.removeClass('inputE');
   passwordCofirm.removeClass('inputE');
   pUserName.removeClass('inputE');
   //call the dialog
   $("#changePasswordDialog").dialog({
      resizable: false,
      height: 470,
      width: 300,
      display: 'inline',
      modal: true,
      buttons:
      [
         {
            text: "Ok",
            click: function () {
               if (!validate()) return;
               var currentLoadingPanel = <any>$find(LogonAspxRadAjaxLoadingPanel1ClientID);
               currentLoadingPanel.show('changePasswordDialogParent');
               var currentDialog = $(this);

               try {
                  // wok - 20.11.17 - added ClientJS for client fingerprinting
                  //var strFieldPINorTAN = cFieldPINorTAN.val;
                  //var strFingerprint = cFieldFingerprint.val;
                  var service = (<any>Sys.Net).WebServiceProxy.invoke("services/PreLoginWS.asmx", "ChangePassword", false, { "pUserName": pUserName.val(), "pOldPassword": oldPassword.val(), "pNewPassword": password.val(), "pPinOrTan": cFieldPINorTAN.val(), "pFingerprint": cFieldFingerprint.val() },
                     function (data, w) {
                        currentLoadingPanel.hide('changePasswordDialogParent');
                        var message = data.ErrorMessage;
                        if (message == "")
                           message = $('#ErrorMessage').text();
                        if (data != null) {
                           var pwdChanged = data.Result;

                           if (!pwdChanged) {
                              e3.text(message);
                              e3.removeClass('labelD');
                              e3.addClass('label');
                           }
                           else {
                              alert(message);
                              currentDialog.dialog("close");
                           }
                        }
                     },
                     function (e, w) {
                        currentLoadingPanel.hide('changePasswordDialogParent');
                        e3.text(e.get_message());
                        e3.removeClass('labelD');
                        e3.addClass('label');
                     },
                     null,
                     30000);

               } catch (ex) {
                  currentLoadingPanel.hide('changePasswordDialogParent');
                  e3.text(ex.message);
                  e3.removeClass('labelD');
                  e3.addClass('label');
               }
            }
         },
         {
            text: $('#ltCancel').text(),
            click: function () {
               $(this).dialog("close");
            }
         }
      ]
   });

   if ($('#changePasswordDialogParent').attr("class") == null || $('#changePasswordDialogParent').attr("class").indexOf('ui-widget') < 0) {
      $('.ui-dialog-titlebar-close').remove();
      $('#changePasswordDialogParent').remove();
      $('#changePasswordDialog').parent().attr('id', 'changePasswordDialogParent');
   }
}
function validate() {
   var e1 = $('#error1');
   var e2 = $('#error2');
   var e3 = $('#error3');
   var e4 = $('#error4');

   var oldPassword = $('#oldPassword');
   var password = $('#password');
   var passwordCofirm = $('#passwordCofirm');
   var pUserName = $('#pUserName');

   if (!emptyValidate(pUserName, e4)) return false;
   if (!containsChar(pUserName, e4, "\\") && !containsChar(pUserName, e4, "@")) {
      e4.text($('#domainError').text());
      return false;
   }
   if (!emptyValidate(oldPassword, e1)) return false;
   if (!emptyValidate(password, e2)) return false;
   if (!emptyValidate(passwordCofirm, e3)) return false;

   if (password.val() != passwordCofirm.val()) {
      passwordCofirm.addClass('inputE');
      e3.text($('#PasswordConfirmError').text());
      e3.removeClass('labelD');
      e3.addClass('label');
      return false;
   }
   else {
      passwordCofirm.removeClass('inputE');
      e3.removeClass('label');
      e3.addClass('labelD');
      return true;
   }
}

function containsChar(input, error, char) {
   if (input.val().indexOf(char) > 0) {
      input.removeClass('inputE');
      error.removeClass('label');
      error.addClass('labelD');
      return true;
   }
   else {
      input.addClass('inputE');
      error.removeClass('labelD');
      error.addClass('label');
      return false;
   }
}
function emptyValidate(input, error) {
   if (input.val() === "") {
      input.addClass('inputE');
      error.removeClass('labelD');
      error.addClass('label');
      //error.text('Leere Eingaben sind nicht erlaubt');
      return false;
   }
   else {
      input.removeClass('inputE');
      error.removeClass('label');
      error.addClass('labelD');
      return true;
   }
}
//OG - 8.10.13 - workaround for the known bug in .net 3.5
//Function.emptyFunction = Function.emptyMethod = function Function$emptyMethod() {}

$(document).ready(function () {
   console.log('is ready')
   // wok - 20.11.17 - added ClientJS for client fingerprinting
   return readyFunctionLogonAspx();
});
